<template>
  <div class="report-details-container w-100">
    <div class="vl-parent">
      <loading v-model:active="isLoading" :can-cancel="true" :is-full-page="fullPage" />
    </div>

    <!-- Search Form -->
    <form class="fed_search mb-4" @submit.prevent="searchnotice()">
      <div class="form-group col-md-4 position-relative mb-2">
        <label class="text-white mb-1">Report Title</label>
        <input
          type="text"
          class="form-control"
          v-model="noticetitle"
          @input="searchInput"
          placeholder="District Name and Title"
          ref="inputField"
        />
        <div class="productlist" v-if="federationok" ref="suggestionsList">
          <ul class="m-0 p-0">
            <li
              @click="selectnotice(notice.reportTitle)"
              v-for="(notice, i) in noticelist"
              :key="i"
            >
              {{ notice.reportTitle }}
            </li>
          </ul>
        </div>
      </div>

      <div class="form-group col-md-3 mb-2">
        <label class="text-white mb-1">Start Date</label>
        <input type="date" class="form-control" v-model="starttime" />
      </div>

      <div class="form-group col-md-3 mb-2">
        <label class="text-white mb-1">End Date</label>
        <input type="date" class="form-control" v-model="endtime" />
      </div>

      <div class="form-group col-md-2 mb-2 d-flex align-items-end">
        <button type="submit" class="btn btn-danger w-100 font-weight-bold" style="height: 38px;">
          <i class="fa fa-search"></i> Search
        </button>
      </div>
    </form>

    <div class="clearfix"></div>

    <!-- Data Table -->
    <div class="table-responsive w-100 mt-3" style="clear: both;">
      <table class="table table-bordered table-striped align-middle mb-0">
        <thead style="background: #333; color: #fff;">
          <tr>
            <th style="width: 60px; text-align: center; color: #fff;">No</th>
            <th style="color: #fff;">Report Title</th>
            <th style="width: 220px; color: #fff;">Date</th>
            <th style="width: 100px; text-align: center; color: #fff;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(notice, index) in paginatedNotices" :key="notice.id || index">
            <td style="text-align: center; vertical-align: middle;">
              {{ (currentPage - 1) * itemsPerPage + index + 1 }}
            </td>
            <td style="vertical-align: middle;">
              {{ notice.reportTitle }}
            </td>
            <td style="vertical-align: middle;">
              {{ formatDate(notice.created_at || notice.date) }}
            </td>
            <td style="text-align: center; vertical-align: middle;">
              <a
                class="btn btn-sm btn-success"
                target="_blank"
                :href="url + 'reports/' + notice.filename"
              >
                <i class="fa fa-eye" aria-hidden="true"></i> View
              </a>
            </td>
          </tr>

          <tr v-if="paginatedNotices.length === 0">
            <td colspan="4" class="text-center py-4 text-muted">
              No reports found
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div
      class="d-flex justify-content-between align-items-center flex-wrap mt-3 mb-4"
      v-if="notices.length > 0"
      style="clear: both;"
    >
      <div class="text-muted small">
        Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to
        {{ Math.min(currentPage * itemsPerPage, notices.length) }} of {{ notices.length }} reports
      </div>

      <nav v-if="totalPages > 1">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" @click.prevent="setPage(currentPage - 1)">&laquo; Prev</a>
          </li>
          <li
            v-for="(page, idx) in displayedPages"
            :key="idx"
            class="page-item"
            :class="{ active: currentPage === page, disabled: page === '...' }"
          >
            <a class="page-link" href="#" @click.prevent="page !== '...' && setPage(page)">
              {{ page }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" @click.prevent="setPage(currentPage + 1)">Next &raquo;</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'ReportDetails',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      notices: [],
      noticelist: [],
      noticetitle: '',
      starttime: '',
      endtime: '',
      federationok: false,
      currentPage: 1,
      itemsPerPage: 10
    };
  },
  computed: {
    url() {
      return this.$store.state.url;
    },
    totalPages() {
      return Math.ceil(this.notices.length / this.itemsPerPage) || 1;
    },
    paginatedNotices() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.notices.slice(start, start + this.itemsPerPage);
    },
    displayedPages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const pages = [];
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        pages.push(1);
        if (current > 3) pages.push('...');
        const start = Math.max(2, current - 1);
        const end = Math.min(total - 1, current + 1);
        for (let i = start; i <= end; i++) {
          if (!pages.includes(i)) pages.push(i);
        }
        if (current < total - 2) pages.push('...');
        if (!pages.includes(total)) pages.push(total);
      }
      return pages;
    }
  },
  created() {
    document.addEventListener('click', this.pageClick);
    this.allnotices();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.pageClick);
  },
  methods: {
    formatDate(dateVal) {
      if (dateVal && moment(dateVal).isValid()) {
        return moment(dateVal).format('LLL');
      }
      return 'N/A';
    },
    setPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    searchnotice() {
      this.isLoading = true;
      axios
        .post(this.url + 'searchreport', {
          noticetitle: this.noticetitle,
          starttime: this.starttime,
          endtime: this.endtime
        })
        .then((response) => {
          this.notices = Array.isArray(response.data) ? response.data : [];
          this.currentPage = 1;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    allnotices() {
      this.isLoading = true;
      axios
        .get(this.url + 'getallreport')
        .then((response) => {
          this.notices = Array.isArray(response.data) ? response.data : [];
          this.currentPage = 1;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    pageClick(event) {
      if (
        this.$refs.inputField &&
        event.target !== this.$refs.inputField &&
        this.$refs.suggestionsList &&
        !this.$refs.suggestionsList.contains(event.target)
      ) {
        this.federationok = false;
      }
    },
    searchInput(event) {
      const query = event.target.value;
      if (!query || query.trim() === '') {
        this.noticelist = [];
        this.federationok = false;
      } else {
        axios
          .get(this.url + 'getreportlist/' + encodeURIComponent(query))
          .then((response) => {
            this.noticelist = Array.isArray(response.data) ? response.data : [];
            this.federationok = this.noticelist.length > 0;
          });
      }
    },
    selectnotice(title) {
      this.noticetitle = title;
      this.federationok = false;
    }
  }
};
</script>

<style scoped>
.report-details-container {
  display: block;
  position: relative;
  width: 100%;
}

form.fed_search {
  background: #3a3f51;
  width: 100%;
  padding: 15px;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  border-radius: 4px;
  float: none !important;
}

.productlist {
  position: absolute;
  background: #333;
  color: white;
  width: 100%;
  z-index: 9999;
  top: 100%;
  left: 0;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.productlist ul {
  list-style: none;
  background: #007bff;
}

.productlist ul li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 12px;
  cursor: pointer;
}

.productlist ul li:hover {
  background: #0056b3;
}

.table-responsive {
  overflow-x: auto;
  clear: both;
}

.page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
}
</style>